import { AnimationState } from "./types";
export class AnimationManager {
  constructor() {
    Object.defineProperty(this, "animations", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(this, "animationState", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: AnimationState.playing
    });
  }
  get requiresUpdate() {
    return this.animations.some(animation => animation.isActive);
  }
  pauseAnimations() {
    this.animationState = AnimationState.paused;
  }
  playAnimations() {
    this.animationState = AnimationState.playing;
  }
  resetAnimations() {
    this.animations.forEach(animation => animation.resetMeshState());
  }
  update(delta) {
    if (this.animationState === AnimationState.paused) return;
    this.animations.forEach(animation => animation.update(delta));
  }
  pushAnimation(animation) {
    this.animations.push(animation);
    return animation;
  }
  cleanAnimations() {
    const keepAnimations = [];
    this.animations.forEach(animation => {
      if (!animation.isComplete) {
        keepAnimations.push(animation);
      }
    });
    this.animations = keepAnimations;
  }
  // Cancel animation that have a specific tag.
  cancelAnimations(tag) {
    this.stopAnimations(tag);
    const filteredAnimations = tag === undefined ? this.animations : this.animations.filter(animation => animation.tags.includes(tag));
    filteredAnimations.forEach(animation => animation.cancel());
  }
  // If tag present stop animations with that tag, else stop all animations
  stopAnimations(tag) {
    if (tag) {
      this.animations.filter(animation => animation.tags.includes(tag)).forEach(animation => animation.stop());
    } else {
      this.animations.forEach(animation => animation.stop());
    }
  }
  // Do not resume animations that contain tag ignoreTag
  resumeAnimations(ignoreTag) {
    if (ignoreTag) {
      this.animations.filter(animation => !animation.tags.includes(ignoreTag)).forEach(animation => animation.start());
    } else {
      this.animations.forEach(animation => animation.resume());
    }
  }
}